@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

$row-height: 23px;
$divider: 1px solid #3e6175;
$background-color: var(--stats-table-background, #e5e5e5);

$z-index-bottom: 1;
$z-index-middle: 2;
$z-index-top: 3;

[data-fpsm-theme='oddschecker'],
[data-fpsm-theme='plus'],
[data-fpsm-theme='whoscored'],
[data-fpsm-theme='gazzetta'] {
  --stats-table-background: initial;
  --stats-table-text: initial;
}

[data-fpsm-theme='plus'] {
  --stats-table-background: #294f66;
}

[data-fpsm-theme='whoscored'] {
  --stats-table-background: var(--cxy-color-surface-primary-default-subtle);
}

[data-fpsm-theme='gazzetta'] {
  --stats-table-text: var(--cxy-color-text-default-placeholder);
  --stats-table-background: #4a4a4a;
}

[data-fpsm-theme='gazzetta'],
[data-fpsm-theme='plus'] {
  .wrapper.wrapper {
    background-color: $background-color;

    &::before,
    &::after,
    div::before,
    div::after {
      background-image: linear-gradient(to left, color-mix(in srgb, $background-color 90%, transparent), transparent);
    }

    div {
      background-color: $background-color;
    }

    h2 {
      color: var(--stats-table-text, var(--cxy-color-content-default));
    }
  }
}

table.table {
  border-collapse: collapse;
  width: 100%;
  color: var(--stats-table-text, var(--cxy-color-content-default));
  transform: var(--table-horizontal-offset);
  transition: transform 0.3s ease;
  will-change: transform;

  .tableHead {
    position: sticky;
    inset-block-start: 0;
    z-index: $z-index-middle;
    height: $row-height;
    background-color: $background-color;
    border-block-end: $divider;

    .tableColumn {
      position: sticky;
      color: #e5e8eb;
      background-color: $background-color;

      div {
        min-width: var(--cellWidth);
        width: 100%;
        padding-inline: var(--cxy-spacing-xxsm);
        background-color: $background-color;
      }

      &[data-justify='center'] {
        div {
          margin: auto;
        }
      }
    }
  }

  .tableBody {
    border-end-start-radius: var(--cxy-border-radius-m);
    border-end-end-radius: var(--cxy-border-radius-m);

    .tableRow {
      height: $row-height;

      .tableCell {
        div {
          min-width: var(--cellWidth);
          width: 100%;
        }
        &[data-highlight='false'] {
          div {
            border-block-end: $divider;
          }
        }

        &[data-highlight='true'] {
          border-width: 2px;
        }
      }
    }
  }

  .tableFooter {
    position: sticky;
    z-index: $z-index-middle;
    inset-block-end: 0;
    height: $row-height;
    background-color: $background-color;
  }

  .tableRow {
    .tableColumn,
    .tableCell {
      height: $row-height;
      padding-block: 0;
      padding-inline: 0;
      width: max-content;

      &[data-highlight='false'] {
        background-color: $background-color;
      }

      > div {
        width: 100%;
        padding-inline: var(--cxy-spacing-xxsm);
        height: inherit;
        padding-block: 0;
      }

      &:last-of-type {
        padding-block: 0;
      }
    }
  }
}

.tableRow {
  @include cxy.screen-size('tablet') {
    [data-pinned='true'] {
      position: sticky;
      background-color: $background-color;
      z-index: $z-index-bottom;

      &:nth-child(1) {
        inset-inline-start: 0;
      }

      &:nth-child(2) {
        inset-inline-start: var(--cellWidth);
      }

      &:nth-child(3) {
        inset-inline-start: calc(var(--cellWidth) * 2);
      }
    }
  }
}
